import React, {Component, ReactElement, ReactNode} from 'react'
import {
    FacilityReserveInfo,
    NatGetFacilityReserveList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetFacilityReserveList'
import {CANCEL_REASON, FACILITY_CATEGORY, RESERVATION_STATUS, SELECT_USER_TYPE} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {FlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'

import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell'
import {SortOrder} from '../../../components/shared/SortOrder'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {formatDateTimeWithoutSeconds, formatForDateInput} from '../../../formatters/formatDate'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatFacilityReserveRepo from './repository/NatFacilityReserveRepo'
import {Messages} from '../../../Messages'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {getYearAfterNextDateFac, getYearDateFac, nullToBlank} from '../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import FacilitiesRepository, {FacilitiesForPagination} from '../../../components/facilities/FacilitiesRepository'
import FacilityForAdmin from '../../../components/facilities/FacilityForAdmin'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {NatGetFacilityReserveDataOutputParams} from './repository/NatGetFacilityReserveDataOutput'
import NatFacilityRepo from '../facility/repository/NatFacilityRepo'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {getDisplayUserNameForManagement} from '../../../components/reservations/admin/AdminReserveHelper'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'
import ReactDOM from 'react-dom'

const KEY_SEARCH_CONDITION: string = 'adminFacilityReserveListPageSearchCondition'
const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    facilityRepo: NatFacilityRepo
    facilitiesRepo: FacilitiesRepository
    RidgeRepo: NatRidgeRepo
    facilityReserveRepo: NatFacilityReserveRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location,
}

interface States {
    facilities: FacilityForAdmin[]
    categories: FACILITY_CATEGORY[]
    facilityId: string
    categoryId: string
    userId: string
    userRidgeCd: string
    userRoomNumber: string
    userRidgeName: string
    userName: string
    adminUserName: string
    reserveStartDate: string
    reserveEndDate: string
    reserveStartDateMin: string
    reserveStartDateMax: string
    reserveEndDateMin: string
    reserveEndDateMax: string
    currentDateTime: CurrentDateTime
    dialogOpenSelectResidentUser: boolean
    selectedResidentUsersRoomInfo: string
    selectedCondominiumCd: string
    facilityReserveInfo: FacilityReserveInfo[]
    facilityReserveSearchResult: SearchResult
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    noResultMessage: string
    reserveDataOutputDisabled: boolean
    isLoadCompleted: boolean
}

class NatFacilityReserveListPage extends Component<Props & AdminPagePropsSet, States> {

    subSortKey: SortOrder = new SortOrder('facilityReserveId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const selectedCondominiumGroupId: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)


        // 前回検索条件が保持されていればデフォルト値として設定する
        let defaultSearchCondition: SearchCondition = {
            reserveStatusList: [
                RESERVATION_STATUS.ELECTION.value,
                RESERVATION_STATUS.WAITING_FOR_CONFIRMATION.value,
            ],
            reserveStartDate: '',
            reserveEndDate: '',
        }
        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            defaultSearchCondition = JSON.parse(sessionStorageSearchCondition)
        }

        this.state = {
            facilities: [],
            categories: [],
            facilityId: (defaultSearchCondition.facilityId) ?
                String(defaultSearchCondition.facilityId) : '',
            categoryId: (defaultSearchCondition.categoryId) ?
                String(defaultSearchCondition.categoryId) : '',
            userId: (defaultSearchCondition.userId) ?
                String(defaultSearchCondition.userId) : '',
            userRidgeCd: (defaultSearchCondition.userRidgeCd) ?
                defaultSearchCondition.userRidgeCd : '',
            userRoomNumber: (defaultSearchCondition.userRoomNumber) ?
                defaultSearchCondition.userRoomNumber : '',
            userRidgeName: (defaultSearchCondition.dispUserRidgeName) ?
                defaultSearchCondition.dispUserRidgeName : '',
            userName: (defaultSearchCondition.dispUserName) ?
                defaultSearchCondition.dispUserName : '',
            adminUserName: (defaultSearchCondition.dispAdminUserName) ?
                defaultSearchCondition.dispAdminUserName : '',
            reserveStartDate: (defaultSearchCondition.reserveStartDate) ?
                defaultSearchCondition.reserveStartDate : '',
            reserveEndDate: (defaultSearchCondition.reserveEndDate) ?
                defaultSearchCondition.reserveEndDate : '',
            reserveStartDateMax: (defaultSearchCondition.reserveEndDate) ?
                defaultSearchCondition.reserveEndDate : '',
            reserveStartDateMin: '',
            reserveEndDateMax: '',
            reserveEndDateMin: (defaultSearchCondition.reserveStartDate) ?
                defaultSearchCondition.reserveStartDate : '',
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            dialogOpenSelectResidentUser: false,
            selectedResidentUsersRoomInfo: '',
            selectedCondominiumCd: String(selectedCondominiumGroupId),
            facilityReserveInfo: [],
            facilityReserveSearchResult: {},
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: {
                ['pageNum']: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                ['page']: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('reserveStartDatetime', 'desc'),
                new SortOrder('reserveEndDatetime', 'desc'),
                new SortOrder('sortOrder', 'asc'),
            ],
            noResultMessage: '',
            reserveDataOutputDisabled: true,
            isLoadCompleted: false,
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.onChangeFacility = this.onChangeFacility.bind(this)
        this.onChangeExtractStartDate = this.onChangeExtractStartDate.bind(this)
        this.onChangeExtractEndDate = this.onChangeExtractEndDate.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.judgeReserveDataOutputDisabled = this.judgeReserveDataOutputDisabled.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSortMessages = this.handleSortMessages.bind(this)
        this.onClickReserveDataOutput = this.onClickReserveDataOutput.bind(this)
        this.handleResidentUserClear = this.handleResidentUserClear.bind(this)
        this.clickStatus = this.clickStatus.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const sortOrders: SortOrder[] = [
            new SortOrder('updateDatetime', 'desc'),
        ]
        try {
            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            const searchCondition = {...this.state.searchCondition}
            let reserveStartDate: string = this.state.reserveStartDate
            let reserveEndDate: string = this.state.reserveEndDate
            if (currentDateTime && currentDateTime.details) {
                const defaultSearchDate = currentDateTime.details.currentDateTime
                if (searchCondition.reserveStartDate === '') {
                    searchCondition.reserveStartDate = formatForDateInput(new Date(defaultSearchDate).toString())
                    searchCondition.reserveEndDate = formatForDateInput(new Date(defaultSearchDate).toString())
                    reserveStartDate = formatForDateInput(new Date(defaultSearchDate).toString())
                    reserveEndDate = formatForDateInput(new Date(defaultSearchDate).toString())
                }
            }
            // 施設一覧取得
            const facilities: Nullable<FacilitiesForPagination> = await this.props.asyncCallFunction(
                this.props.facilityRepo.getNatFacilitiesForAdmin.bind(
                    this.props.facilityRepo,
                    this.state.selectedCondominiumCd,
                    null,
                    sortOrders,
                    undefined,
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )

            if (facilities && facilities.contents) {
                const publicFacility: FacilityForAdmin[] = facilities.contents
                    .filter(facility => facility.releaseSetting)
                const categorySet = new Set(publicFacility.map(facility => {
                    return String(facility.categoryId)
                }))
                const categoryIds = Array.from(categorySet)
                const categories: FACILITY_CATEGORY[] = FACILITY_CATEGORY.values()
                    .filter(item => categoryIds.includes(item.value))

                this.setState({
                    facilities: publicFacility, categories: categories,
                })
            }

            // 追加課金一覧取得
            await this.getFacilityReserveList(
                searchCondition,
                this.state.searchConditionPageInfo,
                this.state.searchConditionSortInfo,
            )

            if (currentDateTime && currentDateTime.details) {
                this.setState({
                    reserveStartDateMin: getYearDateFac(),
                    reserveEndDateMax: getYearAfterNextDateFac(currentDateTime.details.currentDateTime),
                    reserveStartDate: reserveStartDate,
                    reserveEndDate: reserveEndDate,
                    currentDateTime: currentDateTime.details,
                })

                if (this.state.reserveStartDateMax === '') {
                    this.setState({
                        reserveStartDateMax: getYearAfterNextDateFac(currentDateTime.details.currentDateTime),
                    })
                }
                if (this.state.reserveEndDateMin === '') {
                    this.setState({
                        reserveEndDateMin: reserveStartDate,
                    })
                }
            }
            this.setState({
                searchCondition: searchCondition,
            })
        } finally {
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
        this.props.eventEmitter.closeLoading()
    }

    judgeReserveDataOutputDisabled(searchCondition: SearchCondition): void {
        if (searchCondition.reserveStartDate
            && searchCondition.reserveEndDate) {
            const startDate: Date = new Date(searchCondition.reserveStartDate)
            const endDate: Date = new Date(searchCondition.reserveEndDate)
            startDate.setMonth(startDate.getMonth() + 2)

            if (endDate > startDate) {
                this.setState({reserveDataOutputDisabled: true})
            } else {
                this.setState({reserveDataOutputDisabled: false})
            }
        } else {
            this.setState({reserveDataOutputDisabled: true})
        }
    }

    onChangeCategory(event: SelectChangeEvent<unknown>): void {
        const categoryId = event.target.value as string

        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.categoryId = categoryId

        const selectedFacilityInfo = this.state.facilities
            .filter((facility) =>
                String(facility.facilityId) === this.state.facilityId)

        if (categoryId && selectedFacilityInfo[0] &&
            String(selectedFacilityInfo[0].categoryId) !== categoryId) {
            searchCondition.facilityId = ''
            this.setState({facilityId: ''})
        }

        this.setState({categoryId: event.target.value as string})
    }

    onChangeFacility(event: SelectChangeEvent<unknown>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.facilityId = event.target.value as string

        this.setState({facilityId: event.target.value as string})
    }

    onChangeExtractStartDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.reserveStartDate = formatForDateInput(date.toString())
            this.judgeReserveDataOutputDisabled(searchCondition)
        } else {
            searchCondition.reserveStartDate = ''
        }
        this.judgeReserveDataOutputDisabled(searchCondition)

        this.setState({
            reserveStartDate: date !== null ? date.toString() : '',
            reserveEndDateMin: date !== null ? date.toString() : getYearDateFac(),
            searchCondition: searchCondition,
        })
    }

    onChangeExtractEndDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.reserveEndDate = formatForDateInput(date.toString())
            this.judgeReserveDataOutputDisabled(searchCondition)
        } else {
            searchCondition.reserveEndDate = ''
        }
        this.judgeReserveDataOutputDisabled(searchCondition)

        this.setState({
            reserveEndDate: date !== null ? date.toString() : '',
            reserveStartDateMax: date !== null ?
                date.toString() : getYearAfterNextDateFac(this.state.currentDateTime.currentDateTime),
            searchCondition: searchCondition,
        })
    }

    async getFacilityReserveList(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfos: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const response: Nullable<NatGetFacilityReserveList> = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.getFacilityReserveList.bind(
                    this.props.facilityReserveRepo,
                    searchCondition,
                    searchConditionPageInfo,
                    [...searchConditionSortInfos, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (response && response.details) {
                this.setState({
                    facilityReserveInfo: response.details.facilityReserveInfo,
                    facilityReserveSearchResult: response.details.searchResult,
                })
            }
            this.judgeReserveDataOutputDisabled(searchCondition)
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    async onClickReserveDataOutput(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const request: NatGetFacilityReserveDataOutputParams = {
                facilityId: this.state.facilityId,
                categoryId: this.state.categoryId,
                userId: this.state.userId,
                userRidgeCd: this.state.userRidgeCd,
                userRoomNumber: this.state.userRoomNumber,
                reserveStatusList: this.state.searchCondition.reserveStatusList,
                reserveStartDate: formatForDateInput(this.state.reserveStartDate),
                reserveEndDate: formatForDateInput(this.state.reserveEndDate),
            }
            const tempLink: HTMLAnchorElement = document.createElement('a')
            tempLink.href = this.props.facilityReserveRepo.getFacilityReserveDataOutput(request)
            document.body.appendChild(tempLink)
            tempLink.click()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }


    searchResults(): SearchResultCountDisplayProps {
        if (this.state.facilityReserveInfo.length === 0) {
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.facilityReserveSearchResult.total ?
                this.state.facilityReserveSearchResult.total : undefined,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(this.state.searchCondition))
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.getFacilityReserveList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({
            dialogOpenSelectResidentUser: true,
        })
    }

    handleResidentUserClear(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.userId = ''
        searchCondition.userRidgeCd = ''
        searchCondition.userRoomNumber = ''
        searchCondition.dispUserRidgeName = ''
        searchCondition.dispUserName = ''
        searchCondition.dispAdminUserName = ''

        this.setState({
            userId: '',
            userRidgeCd: '',
            userRoomNumber: '',
            userRidgeName: '',
            userName: '',
            adminUserName: '',
            searchCondition: searchCondition,
        })
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    async setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): Promise<void> {
        const displayUserNameForManagement = getDisplayUserNameForManagement(selectedResidentUserInfo)

        // 検索条件
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.userId = selectedResidentUserInfo.sutekiNetId
        searchCondition.userRidgeCd = selectedResidentUserInfo.ridgeCd
        searchCondition.userRoomNumber = selectedResidentUserInfo.roomNumber
        searchCondition.dispUserRidgeName = selectedResidentUserInfo.ridgeName
        searchCondition.dispUserName = `${nullToBlank(selectedResidentUserInfo.familyName)} ${nullToBlank(selectedResidentUserInfo.firstName)}`
        searchCondition.dispAdminUserName = `${nullToBlank(selectedResidentUserInfo.adminFamilyName)} ${nullToBlank(selectedResidentUserInfo.adminFirstName)}`

        this.setState({
            userId: selectedResidentUserInfo.sutekiNetId,
            userRidgeCd: selectedResidentUserInfo.ridgeCd,
            userRoomNumber: selectedResidentUserInfo.roomNumber,
            userRidgeName: selectedResidentUserInfo.ridgeName,
            userName: `${nullToBlank(selectedResidentUserInfo.familyName)} ${nullToBlank(selectedResidentUserInfo.firstName)}`,
            adminUserName: displayUserNameForManagement,
            searchCondition: searchCondition,
            dialogOpenSelectResidentUser: false,
        })
    }

    renderCategorySelect(): ReactNode {
        const categories: OptionProps[] = this.state.categories.map((item) => {
            return ({
                label: `${item.label}`,
                value: `${item.value}`,
            })
        })

        const categoriesData = [{
            label: '全てのカテゴリ',
            value: '',
        }, ...categories]

        return (
            <PPSelect
                autoFocus
                eventEmitter={this.props.eventEmitter}
                data={categoriesData}
                onChange={this.onChangeCategory}
                value={this.state.categoryId}
            />
        )
    }

    renderFacilitySelect(): ReactNode {
        const facilities = this.state.facilities
            .filter((facility) => !this.state.categoryId ||
                String(facility.categoryId) === this.state.categoryId,
            ).map((item) => {
                return ({
                    label: `${item.facilityName}`,
                    value: `${item.facilityId}`,
                })
            })

        const facilitiesData = [{
            label: '施設を選択してください',
            value: '',
        }, ...facilities]

        return (
            <PPSelect
                autoFocus
                eventEmitter={this.props.eventEmitter}
                data={facilitiesData}
                onChange={this.onChangeFacility}
                value={this.state.facilityId}
            />
        )


    }


    renderSelectedResidentUserInfo(): ReactNode {
        if (this.state.userId === '') {
            return ''
        }

        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>
                        {this.state.userRidgeName} {this.state.userRoomNumber}
                    </SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {this.state.userName}
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {this.state.adminUserName}</SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    judgeCheckStatus(status: string): boolean {
        const {reserveStatusList} = this.state.searchCondition
        if (!reserveStatusList) {
            return false
        }
        return reserveStatusList.includes(status)
    }

    clickStatus(label: string, checked: boolean): void {
        const checkedStatus = RESERVATION_STATUS.values()
            .filter(status => status.label === label)
            .map(status => status.value)[0]

        const {reserveStatusList, ...rest} = this.state.searchCondition
        let updated: string[]
        if (reserveStatusList) {
            if (checked) {
                updated = [...reserveStatusList, checkedStatus]
            } else {
                updated = [...reserveStatusList].filter(status => status !== checkedStatus)
            }
            const searchCondition = {...rest, reserveStatusList: updated}
            this.setState({searchCondition})
        } else {
            if (checked) {
                const searchCondition = {...rest, reserveStatusList: [checkedStatus]}
                this.setState({searchCondition})
            }
        }
    }

    renderStatusBox(): ReactNode {
        return (
            <>
                <PPCheckboxGroup
                    row
                    data={RESERVATION_STATUS.values().map(status => ({
                        label: status.label,
                        checked: this.judgeCheckStatus(status.value),
                    }))}
                    onChangeChecked={this.clickStatus}
                />
            </>
        )
    }

    renderFacilityReserveInfo(): ReactNode {
        return (
            <>
                <ConditionTableRow>
                    <ConditionCategoryCell rowSpan={2}>施設情報</ConditionCategoryCell>
                    <ConditionColumNameCell>カテゴリ</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        {this.renderCategorySelect()}
                    </ConditionInputCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>施設を選択</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        {this.renderFacilitySelect()}
                    </ConditionInputCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionCategoryCell>居住者情報</ConditionCategoryCell>
                    <ConditionColumNameCell>ユーザ</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <SelectedFlexContainer>
                            <SelectedFlexWrapper>
                                <AdminDefaultMediumButton
                                    onClick={this.handleOpenResidentUserSelectionDialog}>
                                    選択する
                                </AdminDefaultMediumButton>
                            </SelectedFlexWrapper>
                            {this.renderSelectedResidentUserInfo()}
                            {this.state.userId !== '' &&
                                <SelectedFlexWrapper>
                                    <AdminDefaultMediumButton
                                        onClick={this.handleResidentUserClear}>
                                        クリア
                                    </AdminDefaultMediumButton>
                                </SelectedFlexWrapper>
                            }
                        </SelectedFlexContainer>
                    </ConditionInputCell>
                </ConditionTableRow>
                {this.state.dialogOpenSelectResidentUser &&
                    <NatResidentUserSelectionComponent
                        roomToResidentRepo={this.props.RoomToResidentRepo}
                        ridgeRepo={this.props.RidgeRepo}
                        selectUserType={SELECT_USER_TYPE.USER.value}
                        closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                        setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                        selectedCondominiumCd={this.state.selectedCondominiumCd}
                        invalidUserSelectFlag={true}
                        allResidentStatus={true}
                        eventEmitter={this.props.eventEmitter}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                    />
                }
                <ConditionTableRow>
                    <ConditionCategoryCell>予約情報</ConditionCategoryCell>
                    <ConditionColumNameCell>予約ステータス</ConditionColumNameCell>
                    <ConditionInputCell>{this.renderStatusBox()}</ConditionInputCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionCategoryCell>日付情報</ConditionCategoryCell>
                    <ConditionColumNameCell>利用期間</ConditionColumNameCell>
                    <ConditionInputCell>
                        <LeftRowFlexContainer>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractStartDate}
                                        value={(this.state.reserveStartDate !== '') ?
                                            new Date(this.state.reserveStartDate) : null
                                        }
                                        minDate={(this.state.reserveStartDateMin !== '') ?
                                            new Date(this.state.reserveStartDateMin) : undefined
                                        }
                                        maxDate={(this.state.reserveStartDateMax !== '') ?
                                            new Date(this.state.reserveStartDateMax) : undefined
                                        }
                                    />
                                </FlexBasis>
                                <TermTxt>から</TermTxt>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractEndDate}
                                        value={(this.state.reserveEndDate !== '') ?
                                            new Date(this.state.reserveEndDate) : null
                                        }
                                        minDate={(this.state.reserveEndDateMin !== '') ?
                                            new Date(this.state.reserveEndDateMin) : undefined
                                        }
                                        maxDate={(this.state.reserveEndDateMax !== '') ?
                                            new Date(this.state.reserveEndDateMax) : undefined
                                        }
                                    />
                                </FlexBasis>
                                <TermTxt>まで</TermTxt>
                            </TermWrapper>
                        </LeftRowFlexContainer>
                    </ConditionInputCell>
                    <ConditionButtonCell colSpan={3}>
                        <AdminDefaultMediumButton
                            onClick={this.onClickSearchButton}>
                            予約を検索する
                        </AdminDefaultMediumButton>
                    </ConditionButtonCell>
                </ConditionTableRow>
            </>
        )
    }


    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.getFacilityReserveList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }


    async handleSortMessages(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        let sortOrders: SortOrder[]
        if (sortKey === 'reserveStartDatetime') {
            sortOrders = [
                new SortOrder(sortKey, sortDirection),
                new SortOrder('reserveEndDatetime', sortDirection),
            ]

        } else {
            sortOrders = [new SortOrder(sortKey, sortDirection)]
        }

        await this.getFacilityReserveList(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            userId: this.state.searchCondition.userId,
            userRidgeCd: this.state.searchCondition.userRidgeCd,
            userRoomNumber: this.state.searchCondition.userRoomNumber,
            reserveStartDate: this.state.searchCondition.reserveStartDate,
            reserveEndDate: this.state.searchCondition.reserveEndDate,
        }

        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getFacilityReserveList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})

    }

    renderFacilityReserveRecord(facilityReserveInfo: FacilityReserveInfo): ReactElement {
        const {
            facilityReserveId,
            facilityId,
            facilityName,
            reserveStatus,
            cancelReason,
            reserveStartDatetime,
            reserveEndDatetime,
            userRidgeName,
            userRoomNumber,
            userFamilyName,
            userFirstName,
            adminFamilyName,
            adminFirstName,
            reserverFamilyName,
            reserverFirstName,
            totalCharge,
        } = facilityReserveInfo
        const facilityReserveUrl: string = `/admin/facilityReserve/${facilityId}/${facilityReserveId}`
        const utilizationTime = `${formatDateTimeWithoutSeconds(reserveStartDatetime)}
        ~ ${formatDateTimeWithoutSeconds(reserveEndDatetime)}`
        const cancelReasonString = (reserveStatus !== RESERVATION_STATUS.CANCEL.value || cancelReason === null)
            ? '' : `（${CANCEL_REASON.codeToEnumConstants(cancelReason).label}）`
        const reserveStatusString = `${RESERVATION_STATUS.codeToEnumConstants(reserveStatus).label}${cancelReasonString}`

        return (
            <TableRow key={facilityReserveId}>
                <TableCellWordBreakAll align={'center'}>
                    <Link href={facilityReserveUrl} underline="hover">{facilityName}</Link>
                </TableCellWordBreakAll>
                <PreLineTableCell align={'center'}>
                    {utilizationTime}
                </PreLineTableCell>
                <TableCell align={'center'}>
                    {userRidgeName} {userRoomNumber}
                </TableCell>
                <TableCell align={'center'}>
                    {userFamilyName} {userFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {adminFamilyName} {adminFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {reserverFamilyName} {reserverFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {reserveStatusString}
                </TableCell>
                <TableCell align={'center'}>
                    {formatNumberWithCommas(totalCharge)}円
                </TableCell>
            </TableRow>
        )
    }

    renderFacilityReserveTable(facilityReserveInfo: FacilityReserveInfo[]): Nullable<ReactElement> {
        if (facilityReserveInfo.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {
                id: 'facilityName',
                label: '施設名',
                sortable: true,
                direction: this.getSortDirection('facilityName'),
            },
            {
                id: 'reserveStartDatetime',
                label: '利用時間',
                sortable: true,
                direction: this.getSortDirection('reserveStartDatetime'),
            },
            {id: 'roomNumber', label: '部屋番号'},
            {id: 'name', label: '氏名'},
            {id: 'adminName', label: '管理者確認用氏名'},
            {id: 'reserveName', label: '予約者氏名'},
            {id: 'reserveStatus', label: '予約ステータス'},
            {id: 'totalCharge', label: '利用金額'},
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.facilityReserveSearchResult.total ?
                        this.state.facilityReserveSearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >

                <SortableTableHeader
                    headers={headers}
                    onSortOrderChange={this.handleSortMessages}
                />
                <SortablePaginationTableBody>
                    {this.state.facilityReserveInfo.map(
                        facilityReserve => this.renderFacilityReserveRecord(facilityReserve),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    <ConditionTable>
                        <ConditionTableBody>
                            {this.renderFacilityReserveInfo()}
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.OUTPUT_RESERVE_LIST}>
                    {this.state.facilityReserveInfo.length !== 0 &&
                        <SearchPageActionArea>
                            <AdminDefaultMediumButton
                                onClick={this.onClickReserveDataOutput}
                                disabled={this.state.reserveDataOutputDisabled}>
                                予約情報出力
                            </AdminDefaultMediumButton>
                        </SearchPageActionArea>
                    }
                </AuthorityChecker>
                <PageMainArea>
                    {this.renderFacilityReserveTable(this.state.facilityReserveInfo)}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatFacilityReserveListPage)

const TableCellWordBreakAll = styled(TableCell)`
    &.MuiTableCell-root {
        word-break: break-all;
    }
`
const TermWrapper: StyledDiv = styled.div`
    display: flex;
    flex: 1 1 auto;
    align-items: flex-start;
`

const TermTxt: StyledSpan = styled.span`
    padding: 0 5px 0 5px;
`

const SelectedModalInfoItemValue: StyledSpan = styled.span`
    font-weight: bolder;
    white-space: normal;
    margin-right: 20px;
`

const SelectedModalInfoItemValueCondominium = styled(SelectedModalInfoItemValue)`
    margin-right: 0;
    white-space: normal;
    word-break: break-all;
`

const SelectedFlexContainer = styled(FlexContainer)`
    flex-direction: row;
    align-items: flex-start;
`

const SelectedFlexWrapper = styled.div`
    display: flex;
    padding-right: 15px;
    flex: 1 1 0%;
    align-items: flex-start;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
    flex-grow: 2;
`

const SelectedModalInfoItemLabel: StyledSpan = styled.span`
    font-size: smaller;
    white-space: nowrap;
    margin-left: 20px;
    margin-right: 20px;
`

export const PreLineTableCell = styled(TableCell)`
    white-space: pre-line;
`

const FlexBasis: StyledDiv = styled.div`
    flex: 1 1 0%;
`
